'use client'
var version = "4.6.2";

export { version };
